// App.js
import React from "react";
import { Navigate, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Home2 from "./pages/Home2";
import Layout2 from "./components/Navbar/Layout2";
import Layout3 from "./components/Navbar/Layout3";
import Layout4 from "./components/Navbar/Layout4";
import Layout5 from "./components/Navbar/Layout5";

import FogServicePrograms from "./components/Service/FogServicePrograms";
import A4HCivicLeadership from "./components/Service/A4HCivicLeadership";
import HinduWayOfLiving from "./components/Service/HinduWayOfLiving";
import LeadershipEmpowermentPrograms from "./components/Service/LeadershipEmpowermentPrograms";
import HinduRajneetiAcademy from "./components/Service/HinduRajneetiAcademy";
import HinduVotersGuide from "./components/Service/HinduVotersGuide";
import AlliancesAndCoalitions from "./components/Service/AlliancesAndCoalitions";
import HBSJCongressionalCaucus from "./components/Service/HBSJCongressionalCaucus";
import FogEventsCalendar from "./components/Service/FogEventsCalendar";
import ContactUsMediaPress from "./components/Service/ContactUsMediaPress";
import HomePage from "./components/Service/HomePage";
import AboutUs from "./components/Service/AboutUs";
import ContactA4H from "./components/Contact/ContactA4H";
import FOG2026ProgramSchedule from "./components/Service/FOG2026ProgramSchedule";
import Sponsorship2026 from "./components/Service/Sponsorship2026";
import BecomeVolunteer from "./components/Service/BecomeVolunteer";
import BecomeVolunteer1 from "./components/Service/BecomeVolunteer1.js";
import BecomeVolunteer2 from "./components/Service/BecomeVolunteer2.js";
import BecomeVolunteer3 from "./components/Service/BecomeVolunteer3.js";
import FogMediaPage from "./components/Service/FogMediaPage";
import A4HTEMPLE from "./components/Service/A4HTempleRakshak.js";
import A4HCHARITY from "./components/Service/A4HCharitable.js";
import LEGISLATIVE from "./components/Service/Legislative.js";
import GRASSROOTS from "./components/Service/Grassroots.js";
import PROGRAMS from "./components/Service/RelationsProgram.js";
import CAMPAIGNS from "./components/Service/Campaigns.js";
import POLICY from "./components/Service/PolicyCommunications.js";
import PIPELINE from "./components/Service/AdvocacyPipeline.js";
import ADVOCACYI from "./components/Service/AdvocacyInfrastructure.js";
import COMMUNITY from "./components/Service/COMMUNITYSERVICES.js";
import BhajanClubbing from "./components/Service/BhajanClubbing.js";
import Proclamations from "./components/Service/Proclamations";
import PressReleases from "./components/Service/PressReleases.js";
import A4HFIRST from "./components/Service/A4HFIRST.js";
import A4HSECOND from "./components/Service/A4HSECOND.js";
import A4HTHIRD from "./components/Service/A4HTHIRD.js";
import A4HCHAPTERS from "./components/Service/A4HCHAPTERS.js";
import MISSIONANDGOALS from "./components/Service/MISSIONANDGOALS.js";
import ENDORSMENTS from "./components/Service/ENDORSMENTS.js";
import A4HEVENTS from "./components/Service/A4HEVENTS.js";
import MembershipVolunteer from "./components/Service/MembershipVolunteer.js";
import ARKANSAS from "./components/Service/STATES/ARKANSAS.js";
import ALABAMA from "./components/Service/STATES/ALABAMA.js";
import DELAWARE from "./components/Service/STATES/DELAWARE.js";
import LOUISIANA from "./components/Service/STATES/LOUISIANA.js";
import MISSOURI from "./components/Service/STATES/MISSOURI.js";
import NEWMEXICO from "./components/Service/STATES/NEWMEXICO.js";
import OREGON from "./components/Service/STATES/OREGON.js";
import PENNSYLVANIA from "./components/Service/STATES/PENNSYLVANIA.js";
import WASHINGTON from "./components/Service/STATES/WASHINGTON.js";
import FLORIDA from "./components/Service/STATES/FLORIDA.js";
import COLORADO from "./components/Service/STATES/COLORADO.js";
import OHIO from "./components/Service/STATES/OHIO.js";
import UTAH from "./components/Service/STATES/UTAH.js";
import MASSACHUSETTS from "./components/Service/STATES/MASSACHUSETTS.js";
import NEVADA from "./components/Service/STATES/NEVADA.js";
import CALIFORNIA from "./components/Service/STATES/CALIFORNIA.js";
import TEXAS from "./components/Service/STATES/TEXAS.js";
import NORTHCAROLINA from "./components/Service/STATES/NORTHCAROLINA.js";
import NEWJERSEY from "./components/Service/STATES/NEWJERSEY.js";
import NEWYORK from "./components/Service/STATES/NEWYORK.js";
import ILLINOIS from "./components/Service/STATES/ILLINOIS.js";
import MARYLAND from "./components/Service/STATES/MARYLAND.js";
import SCALIFORNIA from "./components/Service/STATES/SCALIFORNIA.js";
import MICHIGAN from "./components/Service/STATES/MICHIGAN.js";
import KANSAS from "./components/Service/STATES/KANSAS.js";
import VIRGINIA from "./components/Service/STATES/VIRGINIA.js";
import WASHINGTONDC from "./components/Service/STATES/WASHINGTONDC.js";
import ARIZONA from "./components/Service/STATES/ARIZONA.js";
import CONNECTICUT from "./components/Service/STATES/CONNECTICUT.js";
import NEWHAMPSHIRE from "./components/Service/STATES/NEWHAMPSHIRE.js";
import GEORGIA from "./components/Service/STATES/GEORGIA.js";
import MAINE from "./components/Service/STATES/MAINE.js";
import RHODEISLAND from "./components/Service/STATES/RHODEISLAND.js";
import TENNESSEE from "./components/Service/STATES/TENNESSEE.js";
import EMPTY from "./components/Service/STATES/EMPTY.js";
import A4H501C4 from "./components/Service/A4H501C4.js";
import DONATION from "./components/Service/Donations.js";

const legacyRedirects = {
  "/services/about-us": "/about-us",
  "/services/MISSIONANDGOALS": "/mission-and-goals",
  "/services/A4HEVENTS": "/events-and-calender",
  "/services/fog-media-page": "/media",
  "/services/Donations": "/donations",
  "/services/donations": "/donations",
  "/services/A4HFIRST": "/americans4hindus-pac-political-action-committee",
  "/services/a4h-civic-leadership": "/a4h-pac",
  "/services/hindu-voters-guide": "/a4h-voter-guide",
  "/services/ENDORSMENTS": "/a4h-endorsed-candidates",
  "/services/A4HCHAPTERS": "/a4h-state-pacs",
  "/services/press-releases": "/a4h-press-releases",
  "/services/A4HSECOND": "/americans4hindus-501c3-nonprofit",
  "/services/hindu-way-of-living": "/hindu-way-of-living",
  "/services/hindu-rajneeti-academy": "/hindu-rajneeti-academy",
  "/services/alliances-and-coalitions": "/alliances-and-coalitions",
  "/services/hbsj-congressional-caucus": "/hbsj-american-congressional-caucus",
  "/services/A4HTempleRakshak": "/a4h-temple-rakshak",
  "/services/A4HTEMPLERAKSHAK": "/a4h-temple-rakshak",
  "/services/A4HCharitable": "/a4h-charity-and-community",
  "/services/A4H501C4": "/dharma-action-council",
  "/services/Legislative": "/legislative-lobbying",
  "/services/Grassroots": "/grassroots-advocacy",
  "/services/RelationsProgram": "/government-relations",
  "/services/Campaigns": "/issue-based-campaigns",
  "/services/PolicyCommunications": "/public-policy-communications",
  "/services/PolicyCommunicationsCommunications": "/public-policy-communications",
  "/services/AdvocacyPip": "/research-to-advocacy",
  "/services/AdvocacyPipeline": "/research-to-advocacy",
  "/services/AdvocacyInfrastructure": "/advocacy-membership",
  "/services/A4HTHIRD": "/festival-of-globe",
  "/services/COMMUNITYSERVICES": "/fog-community-services",
  "/services/fog-events-calendar": "/fog-festivals-and-programs",
  "/services/Fog-Service-Programs": "/fog-india-day-parade-and-fair",
  "/services/fog-service-programs": "/fog-india-day-parade-and-fair",
  "/services/proclamations": "/fog-proclamations-and-recognitions",
  "/services/membership-volunteer": "/membership-and-volunteer",
  "/services/become-volunteer": "/pac-volunteer",
  "/services/become-volunteer1": "/5o1c3-volunteer",
  "/services/become-volunteer2": "/5o1c4-volunteer",
  "/services/become-volunteer3": "/fog-volunteer",
  "/services/contact-us": "/contact-us",
  "/services/bhajanclubbing": "/bhajanclubbing",
};

function LegacyHashRedirect() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const redirectFromHash = () => {
      const rawHash = window.location.hash;
      if (!rawHash.startsWith("#/")) return;

      const hashPath = rawHash.slice(1);
      const anchorIndex = hashPath.indexOf("#");
      const legacyPath =
        anchorIndex === -1 ? hashPath : hashPath.slice(0, anchorIndex);
      const anchor = anchorIndex === -1 ? "" : hashPath.slice(anchorIndex);
      const target = legacyRedirects[legacyPath];

      if (target) {
        navigate(`${target}${anchor}`, { replace: true });
      }
    };

    redirectFromHash();
    window.addEventListener("hashchange", redirectFromHash);
    return () => window.removeEventListener("hashchange", redirectFromHash);
  }, [navigate]);

  return null;
}

function LegacyPathRedirect({ to }) {
  const { hash } = useLocation();
  return <Navigate to={`${to}${hash}`} replace />;
}

export default function App() {
  return (
    <>
      <LegacyHashRedirect />
      <ScrollToTop />   {/* 👈 ADD THIS LINE */}

      <Routes>
        {Object.entries(legacyRedirects).map(([from, to]) => (
          <Route
            key={from}
            path={from}
            element={<LegacyPathRedirect to={to} />}
          />
        ))}
        <Route path="/pac-volunteer" element={<BecomeVolunteer />} />
        <Route path="/5o1c3-volunteer" element={<BecomeVolunteer1 />} />
        <Route path="/5o1c4-volunteer" element={<BecomeVolunteer2 />} />
        <Route path="/fog-volunteer" element={<BecomeVolunteer3 />} />
        <Route path="/donations" element={<DONATION />} />
        <Route path="/bhajanclubbing" element={<BhajanClubbing />} />
        <Route path="/americans4hindus-pac-political-action-committee" element={<A4HFIRST />} />
        <Route path="/americans4hindus-501c3-nonprofit" element={<A4HSECOND />} />
        <Route path="/festival-of-globe" element={<A4HTHIRD />} />
        <Route path="/dharma-action-council" element={<A4H501C4 />} />
        {/* HOME */}
        <Route path="/" element={<Home2 />} />
          
        <Route path="/services/home" element={<HomePage />} />
        <Route element={<Layout5 />}>
          <Route path="/legislative-lobbying" element={<LEGISLATIVE />} />
          <Route path="/grassroots-advocacy" element={<GRASSROOTS />} />
          <Route path="/government-relations" element={<PROGRAMS />} />
          <Route path="/issue-based-campaigns" element={<CAMPAIGNS />} />
          <Route path="/public-policy-communications" element={<POLICY />} />
          <Route path="/research-to-advocacy" element={<PIPELINE />} />
          <Route path="/advocacy-membership" element={<ADVOCACYI />} />
          


        </Route>
        {/* ROUTES WITH NAVBAR */}
        <Route element={<Layout2 />}>
          
          
          
          <Route path="/hindu-way-of-living" element={<HinduWayOfLiving />} />
          <Route path="/services/leadership-empowerment-programs" element={<LeadershipEmpowermentPrograms />} />
          <Route path="/hindu-rajneeti-academy" element={<HinduRajneetiAcademy />} />
          <Route path="/a4h-temple-rakshak" element={< A4HTEMPLE/>} />
          <Route path="/a4h-charity-and-community" element={< A4HCHARITY/>} />
          <Route path="/alliances-and-coalitions" element={<AlliancesAndCoalitions />} />
          <Route path="/hbsj-american-congressional-caucus" element={<HBSJCongressionalCaucus />} />
          
          <Route path="/contact-us" element={<ContactA4H />} />
          <Route path="/services/fog-2026-program-schedule" element={<FOG2026ProgramSchedule />} />
          <Route path="/services/sponsorship-2026" element={<Sponsorship2026 />} />
          
          <Route path="/media" element={<FogMediaPage />} />
          
          
          <Route path="/americans4hindus-pac-political-action-committee" element={<A4HFIRST />} />
          <Route path="/americans4hindus-501c3-nonprofit" element={<A4HSECOND />} />
          
          
          
          <Route path="/mission-and-goals" element={<MISSIONANDGOALS />} />
          <Route path="/events-and-calender" element={<A4HEVENTS />} />
          
          
          
        </Route>
        <Route element={<Layout3 />}>
          <Route path="/festival-of-globe" element={<A4HTHIRD />} />
          <Route path="/fog-proclamations-and-recognitions" element={<Proclamations />} />
          <Route path="/fog-festivals-and-programs" element={<FogEventsCalendar />} />
          <Route path="/fog-india-day-parade-and-fair" element={<FogServicePrograms />} />
          <Route path="/fog-community-services" element={<COMMUNITY />} />
        </Route>
        <Route element={<Layout4 />}>
          <Route path="/a4h-voter-guide" element={<HinduVotersGuide />} />
          <Route path="/membership-and-volunteer" element={<MembershipVolunteer />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/a4h-pac" element={<A4HCivicLeadership />} />
          <Route path="/a4h-endorsed-candidates" element={<ENDORSMENTS />} />
          <Route path="/a4h-state-pacs" element={<A4HCHAPTERS />} />
          <Route path="/a4h-press-releases" element={<PressReleases />} />
          <Route path="/services/STATES/ARKANSAS" element={<ARKANSAS />} />
          <Route path="/services/STATES/ALABAMA" element={<ALABAMA />} />
          <Route path="/services/STATES/DELAWARE" element={<DELAWARE />} />
          <Route path="/services/STATES/LOUISIANA" element={<LOUISIANA />} />
          <Route path="/services/STATES/MISSOURI" element={<MISSOURI />} />
          <Route path="/services/STATES/NEWMEXICO" element={<NEWMEXICO />} />
          <Route path="/services/STATES/OREGON" element={<OREGON />} />
          <Route path="/services/STATES/PENNSYLVANIA" element={<PENNSYLVANIA />} />
          <Route path="/services/STATES/WASHINGTON" element={<WASHINGTON />} />
          <Route path="/services/STATES/FLORIDA" element={<FLORIDA />} />
          <Route path="/services/STATES/COLORADO" element={<COLORADO />} />
          <Route path="/services/STATES/OHIO" element={<OHIO />} />
          <Route path="/services/STATES/UTAH" element={<UTAH />} />
          <Route path="/services/STATES/MASSACHUSETTS" element={<MASSACHUSETTS />} />
          <Route path="/services/STATES/NEVADA" element={<NEVADA />} />
          <Route path="/services/STATES/CALIFORNIA" element={<CALIFORNIA />} />
          <Route path="/services/STATES/TEXAS" element={<TEXAS />} />
          <Route path="/services/STATES/NORTHCAROLINA" element={<NORTHCAROLINA />} />
          <Route path="/services/STATES/NEWJERSEY" element={<NEWJERSEY />} />
          <Route path="/services/STATES/NEWYORK" element={<NEWYORK />} />
          <Route path="/services/STATES/ILLINOIS" element={<ILLINOIS />} />
          <Route path="/services/STATES/MARYLAND" element={<MARYLAND />} />
          <Route path="/services/STATES/SCALIFORNIA" element={<SCALIFORNIA />} />
          <Route path="/services/STATES/MICHIGAN" element={<MICHIGAN />} />
          <Route path="/services/STATES/KANSAS" element={<KANSAS />} />
          <Route path="/services/STATES/VIRGINIA" element={<VIRGINIA />} />
          <Route path="/services/STATES/WASHINGTONDC" element={<WASHINGTONDC />} />
          <Route path="/services/STATES/ARIZONA" element={<ARIZONA />} />
          <Route path="/services/STATES/CONNECTICUT" element={<CONNECTICUT />} />
          <Route path="/services/STATES/NEWHAMPSHIRE" element={<NEWHAMPSHIRE />} />
          <Route path="/services/STATES/GEORGIA" element={<GEORGIA />} />
          <Route path="/services/STATES/MAINE" element={<MAINE />} />
          <Route path="/services/STATES/RHODEISLAND" element={<RHODEISLAND />} />
          <Route path="/services/STATES/TENNESSEE" element={<TENNESSEE />} />
          <Route path="/services/STATES/EMPTY" element={<EMPTY />} />
        </Route>
        <Route
          path="/contact-us-media-press"
          element={<ContactUsMediaPress />}
        />
      </Routes>
    </>
  );
}
